import React from 'react';
import { Message } from './message.jsx';
import styles from './style.css';

/**
 * Main chat box component with messages and input
 */
export const MainChatBox = ({ 
    messages, 
    dispatch, 
    outputRef, 
    inputMessage, 
    setInputMessage, 
    isResponding, 
    t, 
    send 
}) => (
    <div className={styles.chatbox}>
        <div ref={outputRef} className={styles.output}>
            {messages.map((msg, index) => 
                <Message 
                    key={index}
                    msg={msg} 
                    index={index} 
                    isLast={index == messages.length - 1} 
                    dispatch={dispatch}
                />
            )}
        </div>

        <input
            type="text"
            autoComplete="off"
            placeholder={t(isResponding ? "responding" : "ask")}
            className={styles.input}
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyDown={(key) => key.key == 'Enter' ? send() : null}
            disabled={isResponding}
        />
    </div>
);
